// Merges the old Navbar's two separate Orders buttons (Admin Orders + Factory Orders
// Queue) into one pinned action. If the user has admin.orders, that's the default
// target; else production.orders. Both remain individually reachable from the
// sidebar's Orders group for dual-module users.
export default function useOrdersQuickAction({ hasModule, unseenCount }) {
  const hasAdminOrders = hasModule('admin.orders');
  const hasFactoryOrders = hasModule('production.orders');
  const visible = hasAdminOrders || hasFactoryOrders;
  const target = hasAdminOrders ? '/admin/orders' : (hasFactoryOrders ? '/factory/orders' : null);
  return { visible, target, badgeCount: unseenCount };
}
